import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles(
    (() => {
      const background =
        (theme.portal &&
          theme.portal.header &&
          theme.portal.header.background) ||
        "#333";
      const logo = (theme.portal && theme.portal.logo) || "";
      return {
        contactLogo: {
          backgroundSize: "auto 35px",
          backgroundPosition: "left center",
          backgroundRepeat: "no-repeat",
          backgroundImage: `url(${logo})`,
          flex: 1,
        },
        managerDetails: {
          display: "grid",
        },
        managerPhoto: {
          width: 35,
          height: 35,
          margin: "0 auto"
        },
        contactContainer: {
          backgroundColor: background,
          padding: "20px 20px 0",
        },
      };
    })()
  );
